import { gql } from '@apollo/client';

const UPDATE_CURRENT_UI = gql`
  mutation selfServeUiSwitch($clientId: ID!, $unifiedBanking: Boolean!) {
    selfServeUiSwitch(clientId: $clientId, unifiedBanking: $unifiedBanking)
  }
`;

export default UPDATE_CURRENT_UI;
